// extracted by mini-css-extract-plugin
export default {"root":"category_root__IwYrL"};